// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__3K6AO","rootCenter":"LoadMoreObserver_rootCenter__3iyS7","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__3Tc8u"};